import "./OrderCard.css";

// const paymentData = {
//     refId: info.result.id, //Order id
//     realName: info.result.sellerRealName, // seller actual name on Bybit
//     amount: info.result.amount, //order amount
//     bank: info.result.confirmedPayTerm.bankName, //bank name
//     branch: info.result.confirmedPayTerm.branchName, //bank branch
//     accountNo: info.result.confirmedPayTerm.accountNo, //acc number
//     cardNo: info.result.confirmedPayTerm.debitCardNumber, // card number
//     bankRealName: info.result.confirmedPayTerm.realName, // real name of seller in acc details
//     paymentType: info.result.confirmedPayTerm.paymentType, //Bybit Payment type id
//     paymentName: info.result.confirmedPayTerm.paymentConfigVo.paymentName //Bybit payment type name
// }

const OrderCard = ({orderData, payorder}) => {
    return (
        <article className="order-card">
            <div className="flex order-card-header">
                <div>
                    <p>{orderData.realName}</p>
                    <p className="timestamp">
                        <span>{new Date(parseInt(orderData.orderDate)).toDateString()}</span> | &nbsp;
                        <span>{new Date(parseInt(orderData.orderDate)).toLocaleTimeString()}</span>
                    </p>
                    <p className="timestamp">
                        <span><b>{orderData.buyerReview}% review</b></span> | &nbsp;
                        <span><b>{orderData.buyerOrders} orders</b></span> | &nbsp;
                        <span><b>{orderData.buyerReleaseTime}min</b></span>
                    </p>
                </div>
                <span className="status-span">processing</span>
            </div>

            <div className="order-card-body">
                <p className="amount">N{parseFloat(orderData.amount).toLocaleString()}</p>
                <div className="flex">
                    <p>Order Number</p>
                    <p className="right">{orderData.refId}</p>
                </div>
                <div className="flex">
                    <p>Account Number</p>
                    <p className="right">{orderData.accountNo}</p>
                </div>
                <div className="flex">
                    <p>Bank Name</p>
                    <p className="right">{(orderData.paymentName.toLowerCase() === "bank transfer") ? (orderData.bank || orderData.branch).toUpperCase() : orderData.paymentName}</p>
                </div>
                {
                    orderData.branch &&
                <div className="flex">
                    <p>Bank Branch</p>
                    <p className="right">{orderData.branch}</p>
                </div>
                }
                <div className="flex">
                    <p>Verified Acc. Name</p>
                    <p className="right">{orderData.bankRealName}</p>
                </div>

                <p>
                    <span>Info:</span>
                    <span className="status-span">payment processing</span>
                </p>
            </div>

            <div className="order-card-footer">
                <button onClick={() => payorder(orderData.refId)}> Pay Order</button>
            </div>
        </article>
    )
}

export default OrderCard;